module.exports = __webpack_public_path__ + "img/ge.68bac5b5.svg";